import {
  AppBar,
  Box,
  CssBaseline,
  Drawer,
  Toolbar,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { Outlet } from 'react-router-dom';
import { useState } from 'react';

const drawerWidth = 240;

const AdminLayout = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#f8fafd' }}>
      <CssBaseline />

      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          bgcolor: '#fff',
          color: '#1976d2',
          borderBottom: '1.5px solid #e0e7ef',
          boxShadow: '0 2px 12px 0 #e0e7ef0a',
        }}
      >
        <TopBar onMenuClick={handleDrawerToggle} />
      </AppBar>

      {/* 사이드바: 모바일/데스크탑 공통 통일 */}
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="admin sidebar"
      >
        {/* Mobile */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', sm: 'none' },
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              borderRadius: '0 16px 16px 0',
              borderRight: '1.5px solid #e0e7ef',
              bgcolor: '#fbfbfc',
              boxShadow: '4px 0 32px 0 #1976d225',
            },
          }}
        >
          <Sidebar onNavigate={handleDrawerToggle} />
        </Drawer>

        {/* Desktop */}
        <Drawer
          variant="permanent"
          sx={{
            display: { xs: 'none', sm: 'block' },
            '& .MuiDrawer-paper': {
              width: drawerWidth,
              borderRight: '1.5px solid #e0e7ef',
              bgcolor: '#fbfbfc',
              boxShadow: '2px 0 24px 0 #d6e0f522',
            },
          }}
          open
        >
          <Sidebar />
        </Drawer>
      </Box>

      {/* Main 콘텐츠 */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          px: { xs: 1.5, sm: 3 },
          pt: { xs: 2, sm: 4 },
          mt: 8,
          bgcolor: '#f8fafd',
          minHeight: '100vh',
          width: { sm: `calc(100% - ${drawerWidth}px)` },
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};

export default AdminLayout;
